module.exports = __webpack_public_path__ + "img/56010c6.jpg";